export const MAIN_URL:string="https://priyanshdatyal-me.web.app"

export const enum APP_KEY_IDS{
    FINDER="finder",
    HOME="home",
    ABOUT_ME="about_me",
    ABOUT_SYSTEM="about_system",
    APP_STORE="app_store",
    SAFARI="safari",
    GALLERY="gallery",
    XCODE="xcode",
    SPOTIFY="spotify",
    SETTINGS="settings",
    MESSAGES="messages",
    MUSIC="music",
    NOTES="notes",
    CAMERA="camera",
    CHROME="chrome",
    DEV_SKILLS="dev_skills",
    CONTACTS="contacts",
    HELP="help",
    MOBILE_SPOTIFY="mob_spotify",
    MOBILE_DEV_SKILLS="mobile_dev_skills",
    MOBILE_GALLERY="mob_gallery",
    MOBILE_BIXBY="bixby",
    MOBILE_CAMERA="mob_camera",
    MOBILE_CONTACTS="mob_contact",
    MOBILE_GALAXY_STORE="galaxy_store",
    MOBILE_MAIL="mob_mail",
    MOBILE_MESSAGES="mob_messages",
    MOBILE_MUSIC="mob_music",
    MOBILE_SETTINGS="mob_settings",
    MOBILE_BROWSER="mob_browser",
    MOBILE_PHONE="mob_phone",
    FEEDBACK="feedback",
    MOBILE_FEEDBACK="mob_feedback",
    HIRE="hire",
    LOCK_SCREEN="lock_screen",
    MOBILE_FILE_MANAGER="mob_file_manager",
    AUTH="auth"
}


export const enum APP_TYPE{
    DESKTOP="desktop",
    ANDROID="android",
    WEBSITE="website",
    AIML="aiml",
    CHROME_EXTENSION="chrome_extension"
}

export enum DEVICE_TYPE{
    MOBILE="mobile",
    DESKTOP="desktop"
} 

export enum FILE_EXPLORER_CONTENT_TYPE{
    PDF="pdf",
    WORD="word",
    IMAGE="image",
    VIDEO="video",
    FOLDER="folder"
}

export const colorOptions=[
    {
        id:"blue",
        color:"0,122,255"
    },
    {
        id:"red",
        color:"255,69,58"
    },
    {
        id:"green",
        color:"48,209,88"
    },
    {
        id:"yellow",
        color:"255, 179, 0"
    },
    {
        id:"magenta",
        color:"255,55,95"
    },
    {
        id:"purple",
        color:"175,82,222"
    },
    {
        id:"cyan",
        color:"64,200,224"
    },
    {
        id:"seagreen",
        color:"66, 169, 156"
    }
]


export const aboutSystemInformation=[
    {
        id:"madeWith",
        key:"MadeWith",
        value:"React JS"
    },
    {
        id:"developer",
        key:"Developer",
        value:"Priyansh datyal"
    },
    {
        id:"owner",
        key:"Owner",
        value:"Priyansh datyal"
    },
    {
        id:"status",
        key:"Status",
        value:"Live"
    },
    {
        id:"version",
        key:"Version",
        value:"2.3.1"
    },
    {
        id:"lastVersion",
        key:"Last Version",
        value:"2.2.3"
    }
]